/** Brand-role colours of the non-species chart series, shared by marks and legends. */
import { paletteEconomics, paletteSeries, paletteTone } from './palette';

export const CASHFLOW_COLORS = {
  income: paletteEconomics('income'),
  cost: paletteEconomics('cost'),
  net: paletteEconomics('net'),
  netPos: paletteEconomics('net-pos'),
  netNeg: paletteEconomics('net-neg'),
} as const;

export const CORRIDOR_ROW_COLORS = {
  band: paletteTone('teal'),
  floor: paletteTone('rose'),
  residual: 'var(--fm-d-fg)',
} as const;

/** Observed ink solid, reference amber dashed: never a species slot. */
export const REFERENCE_DEVIATION_COLORS = {
  observed: paletteSeries(0),
  reference: paletteSeries(1),
  surplus: paletteEconomics('net-pos'),
  deficit: paletteEconomics('net-neg'),
} as const;
